import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-diagnosis-node-normal",
  "use": "app-icon-diagnosis-node-normal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-diagnosis-node-normal\"><g fill=\"none\" fill-rule=\"evenodd\"><rect fill=\"#7ADFA0\" width=\"16\" height=\"16\" rx=\"8\" /><path d=\"M3.493 7.264a1 1 0 011.414 0l1.884 1.884 4.264-4.264a1 1 0 011.327-.078l.088.078a1 1 0 010 1.414L7.498 11.27a1 1 0 01-1.414 0L3.493 8.679a1 1 0 010-1.415z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol